import Layout from "../components/layout/Layout"
import Benefit2 from "../components/sections/Benefit2"
import Hero from "../components/sections/Hero"
import RecentPredictions from "../components/sections/RecentPredictions"
import ModelPerformance from "../components/sections/ModelPerformance"
import UpcomingFixtures from "../components/sections/UpcomingFixtures"
import SupportedCompetitions from "../components/sections/SupportedCompetitions"


export default function Home() {

	return (
		<>
			<Layout headerStyle={1} footerStyle={1} breadcrumbTitle="title">
				<Hero />
				<RecentPredictions />
				<UpcomingFixtures />
				<SupportedCompetitions />
				<Benefit2 />
				<ModelPerformance />
			</Layout>
		</>
	)
}